import { dismissKeyboard } from "react-native-web-internals";
const Keyboard = {
  addListener() {
    return { remove: () => {
    } };
  },
  dismiss() {
    dismissKeyboard();
  },
  removeAllListeners() {
  },
  removeListener() {
  }
};
var Keyboard_default = Keyboard;
export {
  Keyboard_default as default
};
//# sourceMappingURL=index.js.map
